import { ChangeDetectionStrategy, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { first } from 'rxjs/operators';

import { AppShellDeactivateAreaDirective } from '@priva/appshell';
import { PrivaLocalizationService } from '@priva/localization';
import { PrivaNotificationsComponent, PrivaNotificationsService } from '@priva/notifications';
import { AppAreaService, AppAreaType } from '@priva/utilities/layout';
import { PrivaToggleClassDirective, PrivaToggleDeactivateDirective } from '@priva/utilities/toggle';

import { ErrorHandlerService } from 'shared/error-handling';

import { PrivaAppVersionAttributes } from './shared/app-version-attributes/app-version-attributes.directive';

@Component({
    selector: 'analytics-app',
    templateUrl: 'app.component.html',
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PrivaAppVersionAttributes,
        PrivaToggleClassDirective,
        AppShellDeactivateAreaDirective,
        PrivaToggleDeactivateDirective,
        PrivaNotificationsComponent,
        RouterOutlet,
    ],
})
export class AppComponent {
    // Root classes
    AreaTypes = AppAreaType;

    // Component existence : visibility
    hasNotificationBar = false;
    hasPrimaryNav = false;
    hasLoadedLanguage = false;

    constructor(
        notificationService: PrivaNotificationsService,
        appAreaService: AppAreaService,
        localizationService: PrivaLocalizationService,
        errorHandler: ErrorHandlerService,
    ) {
        // This is a temporary fix to make sure the empty app has languages
        localizationService.language.pipe(first()).subscribe(() => {
            this.hasLoadedLanguage = true;
        });

        // Has notification bar
        notificationService.barVisibility
            .pipe(takeUntilDestroyed())
            .subscribe((visible) => (this.hasNotificationBar = visible));

        // Has primary nav
        appAreaService
            .hasArea(AppAreaType.PrimaryNav)
            .pipe(takeUntilDestroyed())
            .subscribe((available: boolean) => (this.hasPrimaryNav = available));

        errorHandler.initialize();
    }
}
